import { useContext } from "react";
import { useHistory} from "react-router-dom";

import { useQuery } from "@apollo/client";
import AppBar from "@mui/material/AppBar";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import  Typography from "@mui/material/Typography";

import { GET_FAVOURITE_RECIPES } from "../app/graphql/queries";
import { FavoritesRecipeSelector, setUserFavorites } from "../app/homepage/homepage.slice";
import { userSelector } from "../app/main/mainSlice";
import { useAppDispatch, useAppSelector } from "../app/store/hooks";
import ListView from "../components/listViewPage/ListView";
import useCheckHistory from "../hooks/useCheckHistory";
import useFavoriteRecipes from "../hooks/useFavoriteRecipes";
import useLogRecipeEdit from '../hooks/useLogRecipeEdit';
import { ErrorManagementContext } from "../utils/errorManagement/ErrorManagementProvider";
import { EventLogsEnum } from '../utils/events';
import { BackIcon } from "../utils/iconRefs/recipeStepsIcons";
import { favoriteRecipeIdsTransformerFS2QL } from "../utils/RecipeBackEnd/hasuraFSMigrationTransformers";
import styles from './UserFavorites.module.css'

const UserFavorites = () => {
    const history = useHistory();
    const dispatch = useAppDispatch();

    const favoriteRecipeIds = useAppSelector(FavoritesRecipeSelector);
    const user = useAppSelector(userSelector);
    const { cookClubLog } = useContext(ErrorManagementContext);

    const favoriteRecipes = useFavoriteRecipes();
    const allRecipes = favoriteRecipes.recipes;
    const { logRecipeEdit } = useLogRecipeEdit();
    const goBackOrRedirect = useCheckHistory();

    useQuery(GET_FAVOURITE_RECIPES, {
      skip: !user?.id,
      variables:{userId: user?.id},
      onCompleted:(data)=>{
        const transformedFavoriteRecipeIds = favoriteRecipeIdsTransformerFS2QL(data?.User_favourite_recipes)
        if(transformedFavoriteRecipeIds !== null)
          dispatch(setUserFavorites(transformedFavoriteRecipeIds))
      },
      onError: (err) => {
        history.push('/account');
        cookClubLog(
          "",
          "Unable to fetch favorites recipes!",
          '',
          { ui: { type: "error" }, browserConsole: true });
          console.error('Error fetching the favorites recipes:', err);
      }
    })

    const onBack = () => {
      goBackOrRedirect('/account');
      logRecipeEdit(EventLogsEnum.APP_ING_CHANGES);
    };

    return (
        <Grid id="list-view-container">
      <AppBar className={styles.nav} id="navbar">
        <Grid className={styles.arrow} id="back-icon" onClick={onBack}>
          <BackIcon />
        </Grid>
        {allRecipes.length === 0 && favoriteRecipeIds?.length > 0 ? (
          <Skeleton height="30px" id="header-skeleton" variant="text"
            width="150px" />
        ) : (
          <Grid id="category-header">
            <Typography className={styles.headerText} id="category-name" variant="body3">
              Favorites
            </Typography>
          </Grid>
        )}
        <Grid className={styles.filterIcon} id="filter-icon" />
      </AppBar>
      {favoriteRecipeIds?.length > 0 ? 
        <ListView recipes={allRecipes} /> :  
        <Grid className={styles.no_favorite_wrapper}>
          <Typography className={styles.headerText} id="category-name" variant="body3"> No recipes in favorites </Typography>
        </Grid>
      }
    </Grid>
    );
};

export default UserFavorites;
